import React from 'react'
import { Link } from 'gatsby'
import { Box, Badge, css } from 'theme-ui'
import rv from '@components/utils/buildResponsiveVariant'
import getReadableColor from '@components/utils/getReadableColor'

const styles = {
  badge: {
    mb: 3,
    mr: 2
  }
}

const CardBodyCategory = ({ variant, categories, omitCategory }) => {

  const isDisplayCategories = categories && categories.length && !omitCategory;
  const isSerchCard = (variant[0] === 'cards.search');

  return isDisplayCategories ? (
    <div>
      {
        categories.map((category) => category && category.slug ? (<Box css={css(styles.badge)} sx={{ variant: rv(variant, 'category') }}>
          <Badge
            variant='tag'
            as={Link}
            to={`/category/${category.slug}`}
            sx={
              category.color && {
                bg: category.color,
                color: getReadableColor(category.color)
              }
            }
          >
            {category.name}
          </Badge>
        </Box>) : null)
      }
    </div>
  ) : null
}

export default CardBodyCategory
